module.exports = __webpack_public_path__ + "img/rosette.e121e620.svg";